import {useMemo} from "react";
import {useSelector} from "react-redux";

export default () => {

	const {auth} = useSelector(store => store);

	return useMemo(() => {

		const authedAny = !!(auth?.AuthToken);
		const authed = (authedAny && !auth?.Foreign);
		const authedForeign = (authedAny && auth?.Foreign);

		return {
			auth,
			authed,
			authedAny,
			authedForeign
		};
	}, [auth]);

};
